<template>
<div class='fw-label-card-wrapper'
     :class='{
         "fw-label-card-wrapper--disabled": disabled,
         "fw-label-card-wrapper--error": errorClass,
     }'
     :style='wrapperStyles'>
    <slot name='default'></slot>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class FwLabelCard extends Vue {
    @Prop({ type: String, default: '50px' }) readonly height!: string;
    @Prop({ type: String, default: 'auto' }) readonly width!: string;
    @Prop({ type: String, default: '10px' }) readonly borderRadius!: string;
    @Prop({ type: String, default: '0 20px' }) readonly padding!: string;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Prop({ type: Boolean, default: false }) readonly errorClass!: boolean;

    get wrapperStyles(): { [key: string]: string } {
        return {
            'height': this.height,
            'width': this.width,
            'padding': this.padding,
            'borderRadius': this.borderRadius,
        };
    }
}
</script>

<style lang='sass'>
.fw-label-card-wrapper
    background-color: #F0F2F5
    position: relative

    &--disabled
        opacity: 0.5
        &:before
            content: ''
            position: absolute
            width: 100%
            height: 100%
            z-index: 2
            top: 0
            left: 0
            border-radius: inherit
            cursor: not-allowed
    &--error
      border: 1px solid $main-red
      color: $main-red

</style>
